import React, {useState} from 'react';
import {Button, setOptions} from "@mobiscroll/react";
import '@mobiscroll/react/dist/css/mobiscroll.min.css';
import '../styles/microAppHeader.css';
import {faLanguage} from "@fortawesome/pro-duotone-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

setOptions({
    theme: 'ios',
    themeVariant: 'light',
});

function Header({locale, setLocale, microApp, width}) {
    const [iconHover, setIconHover] = useState(null);

    const ButtonLocale = () => {
        if (window.localStorage.locale === 'en') {
            setLocale(microApp.locale.es);
            window.localStorage.locale = 'es';
        } else if (window.localStorage.locale === 'es') {
            setLocale(microApp.locale.en);
            window.localStorage.locale = 'en';
        }
    }

    return (
        <div className="mbsc-grid cs-microapp-header-toolbar">
            <div className="mbsc-row">
                <div className="mbsc-col">
                    <div className="mbsc-row cs-microapp-header-col-start">
                        <div className="cs-microapp-header-logo" style={{backgroundImage: `url(${microApp.logo})`}} />
                        <Button className="cs-microapp-header-button-text-logo mbsc-bold" variant="flat" >
                            {width > 576 && microApp.displayName}
                        </Button>
                    </div>
                </div>
                <div className="mbsc-col-auto">
                    <div className="mbsc-row cs-microapp-header-col-end">
                        <Button onMouseEnter={() => setIconHover('language')} onMouseLeave={() => setIconHover(null)} title={locale.microAppHeader.a} onClick={() => ButtonLocale()} className="cs-microapp-header-button-text mbsc-bold" variant="flat" >
                            <FontAwesomeIcon className="cs-microapp-header-button-icon" icon={faLanguage} beatFade={iconHover === 'language'} /> {locale.microAppHeader.b}
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Header;
